import { VehicleV10 } from '../../vehicle/model/vehicleV10';
import { JobV10 } from './jobV10';
export class CaseV10 {
    static constructFromPlainObject(sourceCase) {
        const vehicle = sourceCase.vehicle ? VehicleV10.fromPlainObject(sourceCase.vehicle) : null;
        const jobs = sourceCase.jobs ? sourceCase.jobs.map((j) => JobV10.constructFromPlainObject(j)) : [];
        const newCase = new CaseV10(sourceCase.externalId, CaseV10.getDateValue(sourceCase.createdAt), vehicle, sourceCase.assignedDistributionPartnerNumber, sourceCase.assignedOutletNumber, sourceCase.assignedUserId, sourceCase.assignedUserName, sourceCase.brand, sourceCase.comment, sourceCase.dmsOrderNumber, sourceCase.dmsCustomerNumber, sourceCase.isPrivate, jobs, CaseV10.getDateValue(sourceCase.modifiedAt), sourceCase.title, sourceCase.vinLong, sourceCase.vinShort, sourceCase.typeCode, sourceCase.modelDesignation, sourceCase.developmentCode, sourceCase.hasWarnings, sourceCase.hasSalesStop, sourceCase.smallCosyImageUrl);
        return newCase;
    }
    static getDateValue(input) {
        return input && typeof input === 'string' ? new Date(input) : input;
    }
    constructor(externalId, createdAt, vehicle = null, assignedDistributionPartnerNumber, assignedOutletNumber, assignedUserId, assignedUserName, brand, comment, dmsOrderNumber, dmsCustomerNumber, isPrivate = false, jobs = [], modifiedAt, title, vinLong, vinShort, typeCode, modelDesignation, developmentCode, hasWarnings, hasSalesStop, smallCosyImageUrl) {
        this.externalId = externalId;
        this.createdAt = createdAt;
        this.vehicle = vehicle;
        this.assignedDistributionPartnerNumber = assignedDistributionPartnerNumber;
        this.assignedOutletNumber = assignedOutletNumber;
        this.assignedUserId = assignedUserId;
        this.assignedUserName = assignedUserName;
        this.brand = brand;
        this.comment = comment;
        this.dmsOrderNumber = dmsOrderNumber;
        this.dmsCustomerNumber = dmsCustomerNumber;
        this.isPrivate = isPrivate;
        this.jobs = jobs;
        this.modifiedAt = modifiedAt;
        this.title = title;
        this.vinLong = vinLong;
        this.vinShort = vinShort;
        this.typeCode = typeCode;
        this.modelDesignation = modelDesignation;
        this.developmentCode = developmentCode;
        this.hasWarnings = hasWarnings;
        this.hasSalesStop = hasSalesStop;
        this.smallCosyImageUrl = smallCosyImageUrl;
    }
    getAssignedDistributionPartnerNumber() {
        return this.assignedDistributionPartnerNumber;
    }
    setAssignedDistributionPartnerNumber(assignedDistributionPartnerNumber) {
        this.assignedDistributionPartnerNumber = assignedDistributionPartnerNumber;
    }
    getAssignedOutletNumber() {
        return this.assignedOutletNumber;
    }
    setAssignedOutletNumber(assignedOutletNumber) {
        this.assignedOutletNumber = assignedOutletNumber;
    }
    getAssignedUserId() {
        return this.assignedUserId;
    }
    setAssignedUserId(assignedUserId) {
        this.assignedUserId = assignedUserId;
    }
    getAssignedUserName() {
        return this.assignedUserName;
    }
    setAssignedUserName(assignedUserName) {
        this.assignedUserName = assignedUserName;
    }
    getComment() {
        return this.comment;
    }
    setComment(comment) {
        this.comment = comment;
    }
    getCreatedAt() {
        return this.createdAt;
    }
    getDmsOrderNumber() {
        return this.dmsOrderNumber;
    }
    setDmsOrderNumber(dmsOrderNumber) {
        this.dmsOrderNumber = dmsOrderNumber;
    }
    getDmsCustomerNumber() {
        return this.dmsCustomerNumber;
    }
    setDmsCustomerNumber(dmsCustomerNumber) {
        this.dmsCustomerNumber = dmsCustomerNumber;
    }
    getExternalId() {
        return this.externalId;
    }
    setExternalId(externalId) {
        this.externalId = externalId;
    }
    getIsPrivate() {
        return this.isPrivate;
    }
    setIsPrivate(isPrivate) {
        this.isPrivate = isPrivate;
    }
    getModifiedAt() {
        return this.modifiedAt;
    }
    setModifiedAt(modifiedAt) {
        this.modifiedAt = modifiedAt;
    }
    getTitle() {
        return this.title;
    }
    setTitle(title) {
        this.title = title;
    }
    getJobs() {
        return this.jobs;
    }
    getVehicle() {
        return this.vehicle;
    }
    setVehicle(vehicle) {
        this.vehicle = vehicle;
    }
    getBrand() {
        return this.brand;
    }
    setBrand(brand) {
        this.brand = brand;
    }
    getVinLong() {
        return this.vinLong;
    }
    setVinLong(vinLong) {
        this.vinLong = vinLong;
    }
    getVinShort() {
        return this.vinShort;
    }
    setVinShort(vinShort) {
        this.vinShort = vinShort;
    }
    getTypeCode() {
        return this.typeCode;
    }
    setTypeCode(typeCode) {
        this.typeCode = typeCode;
    }
    getModelDesignation() {
        return this.modelDesignation;
    }
    setModelDesignation(modelDesignation) {
        this.modelDesignation = modelDesignation;
    }
    getDevelopmentCode() {
        return this.developmentCode;
    }
    setDevelopmentCode(developmentCode) {
        this.developmentCode = developmentCode;
    }
    getHasWarnings() {
        return this.hasWarnings;
    }
    setHasWarnings(hasWarnings) {
        this.hasWarnings = hasWarnings;
    }
    getHasSalesStop() {
        return this.hasSalesStop;
    }
    setHasSalesStop(hasSalesStop) {
        this.hasSalesStop = hasSalesStop;
    }
    getSmallCosyImageUrl() {
        return this.smallCosyImageUrl;
    }
    setSmallCosyImageUrl(smallCosyImageUrl) {
        this.smallCosyImageUrl = smallCosyImageUrl;
    }
}
//# sourceMappingURL=caseV10.js.map